import { render, staticRenderFns } from "./GiftCardDetails.vue?vue&type=template&id=1d744b15&scoped=true&"
import script from "./GiftCardDetails.vue?vue&type=script&lang=js&"
export * from "./GiftCardDetails.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardDetails.vue?vue&type=style&index=0&id=1d744b15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d744b15",
  null
  
)

export default component.exports